<template>
    <div v-loading="detail_loading">
        <pt-system-customer-with-data :isEdit="isEdit" :userLogin="userLogin" ref="form" @submitLoading="submitLoading" @detailLoading="detailLoading" @deleteLoad="deleteLoad" ></pt-system-customer-with-data>
        <div class="button-div">
            <el-button type="primary" @click="submit" :loading="loading">保存</el-button>
            <el-button type="primary" plain @click="cancel">取消</el-button>
             <el-button type="danger" v-if="isEdit" plain @click="handleDelete" :loading="deleteLoading">删除</el-button>
        </div>
    </div>
</template>
<script>
import ptSystemCustomerWithData from './withData'
export default {
  components: {
    ptSystemCustomerWithData
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    userLogin: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      detail_loading: false,
      deleteLoading: false,
    }
  },
  methods: {
    detailLoading (val) {
      this.detail_loading = val
    },
    submitLoading (val) {
      this.loading = val
    },
    deleteLoad(val) {
      this.deleteLoading = val
    },
    submit () {
      this.$refs.form.submit()
    },
    cancel () {
      history.go(-1)
    },
    handleDelete () {
      this.$refs.form.handleDelete()
    },
  }
}
</script>
<style module lang="less">
</style>
